import ChevronLeft from 'apollo-react-icons/ChevronLeft';
import { useNavigate, useLocation } from 'react-router-dom';
import { adminRoutesConfig, customerRoutesConfig } from '../../routesConfig';

const TitleHeader = (props) => {
  const { title, style, icon } = props;
  const navigate = useNavigate();
  const location = useLocation();

  // Helper to get persona config based on path
  const getPersonaConfig = (pathname) => {
    if (pathname.startsWith('/admin')) return adminRoutesConfig;
    if (pathname.startsWith('/customer')) return customerRoutesConfig;
    return [];
  };

  // Helper to find parent route
  const getParentRoute = (pathname) => {
    const routes = getPersonaConfig(pathname);
    const segments = pathname.split('/').filter(Boolean);

    // Specific condition for /admin/review/:id
    if (pathname.startsWith('/admin/review/')) {
      return '/admin/approvals/requests';
    }
    // Specific condition for ظcustomer/progress
    if (pathname.startsWith('/customer/progress/')) {
      return '/customer/requests/my-requests';
    }

    // Specific condition for workflow version view page
    if (pathname.match(/\/admin\/workflows\/\d+\/versions\/\d+\/view$/)) {
      const workflowId = pathname.match(/\/workflows\/(\d+)\//)[1];
      return `/admin/workflows/${workflowId}/versions`;
    }

    // Specific condition for category organizations page
    if (
      pathname.match(/\/admin\/categories\/\d+\/organizations$/) ||
      pathname.match(/\/admin\/categories\/edit\/\d+$/)
    ) {
      return `/admin/categories`;
    }

    // Remove last segment and try to match
    for (let i = segments.length - 1; i > 0; i--) {
      const parentPath = `/${segments.slice(0, i).join('/')}`;
      if (
        routes.some((route) => {
          // Replace :params with regex wildcards
          const routePattern = route.path.replace(/:[^/]+/g, '[^/]+');
          const regex = new RegExp(`^${routePattern}$`);
          return regex.test(parentPath);
        })
      ) {
        return parentPath;
      }
    }
    // Fallback to persona home
    if (pathname.startsWith('/admin')) return '/admin';
    if (pathname.startsWith('/customer')) return '/customer/home';
    return '/';
  };

  return (
    <>
      <div
        style={{
          ...style,
          height: '98px',
          marginBottom: '20px',
          border: '1px solid #E9E9E9',
          borderRadius: '5px',
          padding: '24px 24px 24px 20px',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
          }}
          onClick={() => {
            const parent = getParentRoute(location.pathname);
            navigate(parent);
          }}
        >
          <ChevronLeft
            style={{
              color: '#0768FD',
              width: '0.5em',
              height: '0.5em',
              marginRight: '20px',
            }}
          />
        </div>
        <div
          style={{
            fontSize: '26px',
            borderLeft: '1px solid #E9E9E9',
            paddingLeft: '20px',
            display: 'flex',
          }}
        >
          <div
            style={{
              marginRight: '20px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {icon}
          </div>
          <div
            className="capitalize"
            style={{
              color: '#444444',
              fontFamily: 'Proxima Nova',
              display: 'flex',
              alignItems: 'center',
              fontWeight: 400,
            }}
          >
            {title}
          </div>
        </div>
      </div>
    </>
  );
};

export default TitleHeader;
